var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJammeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299.001,
    height: 58.493,
    viewBox: "0 0 299.001 58.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jamme_logo",
    transform: "translate(-46.999 -74.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1105015",
    "data-name": "Group 1105015",
    transform: "translate(-9 3.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1105013",
    "data-name": "Group 1105013",
    transform: "translate(55.999 71.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1526005",
    "data-name": "Path 1526005",
    d: "M47.84,83.36v3.261H67.893V66.562H62.965a5.394,5.394,0,0,0,.372-1.982,5.468,5.468,0,1,0-10.569,1.982H47.84v3.282a7.057,7.057,0,0,1,0,13.542Z",
    transform: "translate(-22.792 -28.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526006",
    "data-name": "Path 1526006",
    d: "M22.073,93.373V88.445a5.545,5.545,0,0,0,2.621.336,5.473,5.473,0,0,0-.645-10.9,5.547,5.547,0,0,0-1.982.372V73.32H18.66a7.051,7.051,0,0,1-13.232,0H2.02A20.052,20.052,0,0,0,22.073,93.373Z",
    transform: "translate(-0.993 -34.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526007",
    "data-name": "Path 1526007",
    d: "M6.8,47.553a5.38,5.38,0,0,0-.215,1.52,5.468,5.468,0,0,0,10.936,0,5.378,5.378,0,0,0-.215-1.52h4.771V43.836a7.051,7.051,0,0,1,0-13.536V27.5H2.02V47.553Z",
    transform: "translate(-0.993 -13.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526008",
    "data-name": "Path 1526008",
    d: "M38.436,42.5a5.547,5.547,0,0,0,2.621-.336v5.389h3.261a7.051,7.051,0,0,1,13.536,0H61.11A20.053,20.053,0,0,0,41.057,27.5v4.467A5.473,5.473,0,1,0,38.436,42.5Z",
    transform: "translate(-16.009 -13.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526015",
    "data-name": "Path 1526015",
    d: "M1.151,13.521.1,9a1.919,1.919,0,0,1,1.62-2.3l4.76-.849L3.72,13.065ZM7.967,12.3l6.658-1.19L17.361,3.9l-6.642,1.19L7.982,12.3Zm10.91-1.95L21.618,3.14l6.653-1.19L25.545,9.159l-6.653,1.19ZM32.507,1.19,39.16,0,36.423,7.2l-6.6,1.19Z",
    transform: "translate(-0.062)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1105212",
    "data-name": "Group 1105212",
    transform: "translate(101.188 107.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1526224",
    "data-name": "Path 1526224",
    d: "M20.818,1.476v.692h-2.1V15.576a8.666,8.666,0,0,1-2.875,6.84,11.059,11.059,0,0,1-7.6,2.455A9.884,9.884,0,0,1,3.36,23.823a7.47,7.47,0,0,1-2.98-3.357,2.791,2.791,0,0,1,2.329-4.2,2.6,2.6,0,0,1,1.909.8,2.539,2.539,0,0,1,.818,1.909,2.1,2.1,0,0,1-.42,1.3,3.193,3.193,0,0,1-.4.462l-.252.252-.231.273a1.133,1.133,0,0,0,.189,1.8,3.882,3.882,0,0,0,2.686.881,4.868,4.868,0,0,0,4.2-1.553,9.505,9.505,0,0,0,.8-4.721V2.064h-2.1V1.371Z",
    transform: "translate(0 0.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526225",
    "data-name": "Path 1526225",
    d: "M26.919,1.371,36.8,23.781h2.1v.692H27.191v-.692h2.1l-3-6.756H18.106l-3,6.756h2.77v.692H12v-.692h2.392l7.47-16.786,2.413-5.518ZM18.526,16.332h7.6l-3.8-8.6Z",
    transform: "translate(13.179 0.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526226",
    "data-name": "Path 1526226",
    d: "M56.452,1.371v.692h-2.1V23.781h2.1v.692H45.52v-.692h2.1V3.469l-4.847,12.59-3.189,8.393h-.755l-7.7-20.1V23.76h2.1v.692H28V23.76h2.1V2.064H28V1.371h9.064l5.288,13.786L47.808,1.371Z",
    transform: "translate(30.751 0.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526227",
    "data-name": "Path 1526227",
    d: "M73.452,1.371v.692h-2.1V23.781h2.1v.692H62.52v-.692h2.1V3.469l-4.847,12.59-3.189,8.393h-.755l-7.7-20.1V23.76h2.1v.692H45V23.76h2.1V2.064H45V1.371h9.064l5.288,13.786L64.808,1.371Z",
    transform: "translate(49.422 0.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526228",
    "data-name": "Path 1526228",
    d: "M63.242,23.174a1.386,1.386,0,0,0,.638-.235.619.619,0,0,0,.168-.5V3.719a.619.619,0,0,0-.168-.5,1.386,1.386,0,0,0-.638-.235L62,2.712V1.352H82.68v6.9h-.839A18.026,18.026,0,0,0,80.5,4.961a4,4,0,0,0-1.712-1.679,6.939,6.939,0,0,0-3.122-.571H70.9v8.88h8.662V12.6H70.9V23.107H76a6.731,6.731,0,0,0,3.122-.6A4.312,4.312,0,0,0,80.9,20.757a17.353,17.353,0,0,0,1.376-3.324h.873v7.04H62v-1.03Z",
    transform: "translate(68.092 0.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526229",
    "data-name": "Path 1526229",
    d: "M90.241,12.244l.818.126h.567l.671.1a16.071,16.071,0,0,1,3.168.839,5.5,5.5,0,0,1,4.2,5.246c0,2.917-1.721,4.889-5.183,5.938a20.778,20.778,0,0,1-4.05.692H87.45A11.393,11.393,0,0,1,80.8,23.281a5.959,5.959,0,0,1-2.791-4.343,2.316,2.316,0,0,1,0-.378,2.466,2.466,0,1,1,4.931,0,2.434,2.434,0,0,1-.692,1.742,2.35,2.35,0,0,1-.776.546,1.527,1.527,0,0,1-.441.147h-.483a.525.525,0,0,0-.4.273.609.609,0,0,0,0,.5,1.68,1.68,0,0,0,.462.525l.273.21h.273a13.016,13.016,0,0,0,1.259.734,9.8,9.8,0,0,0,2.686.86,6.832,6.832,0,0,0,1.427.1A4.784,4.784,0,0,0,90.3,22.4a6.525,6.525,0,0,0,1.28-4.2,5.519,5.519,0,0,0-2.707-5.141,7.846,7.846,0,0,0-1.93-.734,3.293,3.293,0,0,0-.629-.1h-.294v-.692a5.833,5.833,0,0,0,3.609-1.28A4.427,4.427,0,0,0,91.521,6.6a5.035,5.035,0,0,0-1.364-3.777A3.966,3.966,0,0,0,87.282,1.69a8.96,8.96,0,0,0-4.2.9,2.246,2.246,0,0,0-1.007.755.8.8,0,0,0,.21,1.049l.294.231.273.231a2.451,2.451,0,0,1,.525.441A1.719,1.719,0,0,1,83.9,6.621a2.224,2.224,0,0,1-.671,1.616,2.1,2.1,0,0,1-1.616.671A2.287,2.287,0,0,1,79.33,6.621v-.21a4.868,4.868,0,0,1,2.329-3.819A9.421,9.421,0,0,1,87.2,1a15.485,15.485,0,0,1,7.889,1.742A4.574,4.574,0,0,1,97.836,6.6a4.532,4.532,0,0,1-3.525,4.322,15.128,15.128,0,0,1-2.644.671H90.639Z",
    transform: "translate(85.664 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526230",
    "data-name": "Path 1526230",
    d: "M114.376,1.371v.692h-2.1V24.473h-.923v-.1L94.716,5.484v18.36h2.1v.692H91.673v-.692h2.1V2.064h-2.1V1.371h8.393l.609.692,10.7,12.212V2.064h-2.1V1.371Z",
    transform: "translate(100.681 0.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526231",
    "data-name": "Path 1526231",
    d: "M118.836,1.371l9.82,22.409h2.1v.692H118.982v-.692h2.1l-2.917-6.756h-8.183l-3,6.756h2.791v.692h-5.917v-.692h2.392l7.47-16.786,2.413-5.518Zm-8.393,14.961h7.6l-3.8-8.6Z",
    transform: "translate(114.059 0.429)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJammeLogo);
export default __webpack_public_path__ + "static/media/jamme_logo.8c29994b76ade66f2a5432c1cad818f7.svg";
export { ForwardRef as ReactComponent };